import { render, staticRenderFns } from "./CbsObjectsMount.vue?vue&type=template&id=196487fe&scoped=true"
import script from "./CbsObjectsMount.vue?vue&type=script&lang=js"
export * from "./CbsObjectsMount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196487fe",
  null
  
)

export default component.exports